export const Screen = {
  INFORMATION: 'information',
  IMAGE_CLEANER: 'image_cleaner',
};
